import uuid from 'uuid/v4';
import sortBy from 'lodash/sortBy';
import isUndefined from 'lodash/isUndefined';
import { RxSocketUrls } from '@Constants/CommonConstants';
import SocketBroker from '@Services/SocketBroker';

class FindPreparationsWSService {
  _unsubscribeError;

  _unsubscribeResults;

  _unsubscribeCustom;

  _listenWS = (url, searchId) => {
    const channels = {
      send: url,
      message: url,
    };

    const request = {
      searchId,
      params: {},
    };

    Logger.info('Send query (_listenWS)');

    return SocketBroker.send(channels, request);
  };

  _initDatabase = (database, products) => {
    if (isUndefined(products)) {
      throw new Error(`manualSynthesisService: no products received for database ${database.databaseId}`);
    }

    const { resultName, databaseId, context, resultSize, hitSetKey, queryId } = database;
    return {
      resultName,
      databaseId,
      context,
      resultSize,
      hitSetKey,
      queryId,
      pageNumber: 1,
      sort: '',
      synthesisProducts: products,
    };
  };

  _prepareDatabases = (databases = []) => {
    return sortBy(
      databases.filter((database) => database.resultSize),
      (database) => parseInt(database.databaseId, 10)
    );
  };

  _setupWebSockets({ resolve, reject }) {
    const uniqId = uuid();
    const customInfoId = `custom-info-${uniqId}`;
    const searchInfoId = `search-info-${uniqId}`;

    let databaseCount = 0;
    let receivedDatabases;
    let productsMap = {};

    this._unsubscribeCustom = () => SocketBroker.stop(customInfoId);
    this._unsubscribeResults = () => SocketBroker.stop(searchInfoId);
    this._unsubscribeError = SocketBroker.observe(RxSocketUrls.ChannelsUrls.QueueErrors, (data) => {
      Logger.warn('WS databases for manual synthesis unexpected error:', data);
      reject(data);
      this.unsubscribeAll();
    });

    const handleListenWSError = (error) => {
      if (error === 'stop' || error === 'stopAll') {
        Logger.debug('FindPreparationsWSService stop');
      } else {
        Logger.error(error);
      }
      // resolve();
    };

    this._listenWS(RxSocketUrls.ChannelsUrls.planner.custom, customInfoId).subscribe({
      next: ({ data }) => {
        if (data && data.payload) {
          productsMap = data.payload;
          this._unsubscribeCustom();
        }
      },
      error: handleListenWSError,
    });

    this._listenWS(RxSocketUrls.ChannelsUrls.SearchInfo, searchInfoId).subscribe({
      next: ({ data }) => {
        if (data && data.payload) {
          if (data.payload.items) {
            receivedDatabases = [];
            databaseCount = data.payload.items.length;
            return;
          }

          const products = productsMap[data.payload.databaseId];
          receivedDatabases.push(this._initDatabase(data.payload, products));

          if (receivedDatabases.length === databaseCount) {
            const databases = this._prepareDatabases(receivedDatabases);
            resolve({ databases, productsMap });
            this.unsubscribeAll();
          }
        }
      },
      error: handleListenWSError,
    });
  }

  _sendRequest = (databaseId, substanceId) => {
    const searchId = uuid();

    SocketBroker.send(
      {
        send: RxSocketUrls.ManualSynthesis,
      },
      {
        searchId,
        params: {
          databaseId,
          substanceId,
          searchId,
        },
      }
    );
  };

  findPreparations(substanceId, databaseId) {
    return new Promise((resolve, reject) => {
      this.unsubscribeAll();
      this._setupWebSockets({ resolve, reject });
      this._sendRequest(databaseId, substanceId);
    });
  }

  unsubscribeAll() {
    if (this._unsubscribeError) {
      this._unsubscribeError();
    }
    if (this._unsubscribeResults) {
      this._unsubscribeResults();
    }
    if (this._unsubscribeCustom) {
      this._unsubscribeCustom();
    }
  }
}

export default new FindPreparationsWSService();
